//src/graphql
import gql from "graphql-tag";

const segmentsThatAreNotInCompleteStateQuery = gql`
query listConnect2WalletSegmentsThatAreNotInCompleteState {
  listConnect2WalletSegments(filter: {
    generateTechsStatus: {
      ne: "Completed"
    }
  }) {
   items {
     id
     errorMessage
     generateTechsStatus
     tech_generation_info
     isLocked
   }
    
  }
}
`;

export default segmentsThatAreNotInCompleteStateQuery;
